// extracted by mini-css-extract-plugin
module.exports = {"input":"NameInput_input__2q--B","nameInput":"NameInput_nameInput__1JUvb","button":"NameInput_button__HN4Hr"};